import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import faTrash from '@fortawesome/fontawesome-pro-light/faTrash';
import T from './Translate';
import signatureMouse from '../images/signature-mouse.svg';
import signatureHand from '../images/signature-hand.svg';

const PEN_COLOR = '#0021B4';

const PLACEHOLDERS = {
	desktop: { url: signatureMouse, width: 971.68 / 3.7, height: 498.55 / 3.7 },
	touch: { url: signatureHand, width: 992.38 / 5, height: 543.71 / 5 },
};

class SignatureInput extends Component {

	signaturePad = null;
	hasPlaceholder = false;
	// signature_pad.fromDataURL() jen vykreslí uložený obrázek do canvasu, ale neobnoví interní
	// seznam bodů (_data), ze kterého se skládá výstupní SVG - po obnovení podpisu je tedy _data
	// prázdné, přestože isEmpty() už vrací false. Kdyby se v tuhle chvíli zavolalo toDataURL(),
	// vznikl by prázdný SVG, který by přepsal uložený podpis. Proto se do redux ukládá znovu jen
	// tehdy, když uživatel v tomto mountu opravdu něco nakreslil.
	hasNewStroke = false;
	// Pokud uživatel po obnovení podpisu (viz výše) domaluje další čáru, _data obsahuje jen tu
	// novou čáru - export do SVG by tak zahodil obnovenou (jen vykreslenou, nikoli vektorovou)
	// část podpisu. V tomto případě proto exportujeme celý canvas jako rastr (PNG), který
	// obsahuje obě části správně. Backend (Guest::saveSignature) umí uložit oba formáty.
	wasRestored = false;

	state = {
		drawing: false,
	};

	componentDidMount() {
		const canvas = this.canvasEl;
		if (!canvas || !window.SignaturePad) return;

		// signature_pad počítá viewBox generovaného SVG jako canvas.width / devicePixelRatio,
		// canvas proto musí mít vnitřní rozlišení vynásobené poměrem, jinak dojde k oříznutí podpisu
		const ratio = Math.max(window.devicePixelRatio || 1, 1);
		canvas.width = canvas.offsetWidth * ratio;
		canvas.height = canvas.offsetHeight * ratio;
		canvas.getContext('2d').scale(ratio, ratio);

		this.signaturePad = new window.SignaturePad(canvas, { penColor: PEN_COLOR });

		if (this.props.input.value) {
			this.signaturePad.fromDataURL(this.props.input.value);
			this.wasRestored = true;
			this.setState({ drawing: true });
		} else {
			this.drawPlaceholder();
		}

		this.signaturePad.addEventListener('beginStroke', this.onBeginStroke);
		this.signaturePad.addEventListener('endStroke', this.onStroke);
		canvas.addEventListener('mouseout', this.onMouseOut);
		// signature_pad poslouchá pointermove jen na canvasu - pokud podpisové pole sousedí
		// s fixní spodní lištou (Navbar), přejetí kurzoru přes ni uprostřed tahu podpis přeruší.
		// Explicitním capture dostane canvas pointer eventy po celou dobu tahu bez ohledu na to,
		// co je vizuálně pod kurzorem.
		canvas.addEventListener('pointerdown', this.onPointerDown);
	}

	drawPlaceholder = () => {
		const canvas = this.canvasEl;
		const placeholder = ('ontouchstart' in window) ? PLACEHOLDERS.touch : PLACEHOLDERS.desktop;

		this.hasPlaceholder = true;

		this.signaturePad.fromDataURL(placeholder.url, {
			width: placeholder.width,
			height: placeholder.height,
			xOffset: canvas.offsetWidth / 2 - placeholder.width / 2,
			yOffset: canvas.offsetHeight / 2 - placeholder.height / 2,
		});
	};

	componentWillUnmount() {
		if (this.signaturePad) {
			this.signaturePad.off();
		}
		if (this.canvasEl) {
			this.canvasEl.removeEventListener('mouseout', this.onMouseOut);
			this.canvasEl.removeEventListener('pointerdown', this.onPointerDown);
		}
	}

	onPointerDown = (e) => {
		if (this.canvasEl.setPointerCapture && e.pointerId !== undefined) {
			this.canvasEl.setPointerCapture(e.pointerId);
		}
	};

	onBeginStroke = () => {
		if (this.hasPlaceholder) {
			this.hasPlaceholder = false;
			this.signaturePad.clear();
		}
		this.hasNewStroke = true;
		this.setState({ drawing: true });
	};

	onStroke = () => {
		this.updateValue();
	};

	onMouseOut = () => {
		if (this.signaturePad && this.hasNewStroke && !this.hasPlaceholder && !this.signaturePad.isEmpty()) {
			this.updateValue();
		}
	};

	updateValue = () => {
		const format = this.wasRestored ? 'image/png' : 'image/svg+xml';
		this.props.input.onChange(this.signaturePad.toDataURL(format));
	};

	onClear = (e) => {
		e.preventDefault();

		if (this.signaturePad) {
			this.signaturePad.clear();
			this.drawPlaceholder();
		}
		this.hasNewStroke = false;
		this.wasRestored = false;
		this.setState({ drawing: false });
		this.props.input.onChange('');
	};

	render() {
		const { label, meta } = this.props;

		const error = meta && meta.error ? meta.error : false;
		const filled = !!(this.props.input && this.props.input.value);

		return (
			<div className="large-input-container">
				<div className={`large-input large-input--sign ${filled ? 'large-input--filled' : ''} ${error ? 'large-input--error' : ''}`}>
					<label>{label}</label>
					<canvas className="sign-canvas" ref={el => this.canvasEl = el} />
					{!filled && !this.state.drawing &&
					<span><T id="GuestDetails.signature.placeholder" /></span>
					}
					<button type="button" className="sign-clear" onClick={this.onClear}>
						<FontAwesomeIcon icon={faTrash} />
					</button>
				</div>
				{error && <div className="large-input-container__error"><T id={error} /></div>}
			</div>
		);
	}
}

export default SignatureInput;



// WEBPACK FOOTER //
// ./src/components/SignatureInput.jsx